const junoSound = {
  title: "SOUND GENERATOR",
  menu: {
    music: "Music",
    sfx: "SFX",
    voice: "Voice",
    library: "Library",
  },
  ai: {
    select: "Please select an AI model",
    model: "Model",
    cassetteai: {
      title: "CassetteAI",
      description:
        "Generate high-quality music from text descriptions with CassetteAI's powerful music generation model.",
      category: ["Music", "Lyrics"],
    },
    cassetteai_sfx: {
      title: "CassetteAI SFX",
      description:
        "Create realistic sound effects for any scenario with CassetteAI's specialized sound effect generation model.",
      category: ["Sound Effects"],
    },
    diffrhythm: {
      title: "DiffRhythm",
      description: "Create music with precise rhythm control and melody using advanced diffusion model technology.",
      category: ["Music", "Lyrics"],
    },
    elevenlabs: {
      title: "ElevenLabs SFX",
      description: "Generate realistic sound effects for any scenario or environment with high fidelity.",
      category: ["Sound Effects"],
    },
    minimax: {
      title: "MiniMax Music",
      description:
        "Create music in various styles with exceptional quality, especially optimized for instrumental tracks.",
      category: ["Music", "Lyrics"],
    },
    mmaudio: {
      title: "MMAudio",
      description: "Generate both music and sound effects with versatile audio generation capabilities.",
      category: ["Sound Effects", "Music"],
    },
    ace_step_audio_to_audio: {
      title: "ACE Step Audio-to-Audio",
      description: "Transform existing audio with high-quality remix capabilities. Upload audio to apply new styles.",
      category: ["Music", "Reference"],
    },
    ace_step: {
      title: "ACE Step Lyrics to Audio",
      description: "Generate high-quality music with control over tags, duration, and lyrics for precise sound design.",
      category: ["Music"],
    },
    ace_step_prompt_to_audio: {
      title: "ACE Step Prompt-to-Audio",
      description: "Create music directly from descriptive prompts with options for instrumental or vocal tracks.",
      category: ["Music"],
    },
    lyria2: {
      title: "Lyria 2",
      description: "Google's Lyria 2 generates high-quality music from prompts in about 30 seconds.",
      category: ["Music"],
    },
  },
  category: {
    music: "Music",
    sfx: "Sound Effects",
    lyric: "Lyrics",
    reference: "Reference",
  },
  params: {
    settings: "Sound Settings",
    ref: "Reference Audio",
    upload: "Upload Audio",
    duration: "Duration (seconds)",
    durationHelp: "Set the duration for your generated sound (in seconds)",
    guidanceScale: "Guidance Scale",
    guidanceScaleHelp: "Adjusts the balance between quality and creativity in sound generation",
    step: "Steps",
    stepHelp:
      "Controls the number of denoising steps, higher values yield better quality at the cost of generation time",
    lyric: "Lyrics",
    lyricPlaceholder: "Enter lyrics for your music",
    lyricHelp: "Add lyrics to guide the music generation. You can use formatting like line breaks for structure.",
    lyricOnlyEnglish: "This model only supports English lyrics.",
    negativePrompt: "Negative Prompt",
    negativePromptPlaceholder: "Enter elements you want to avoid in the sound",
    negativePromptHelp: "Specify what you don't want in the generated sound",
    category: "Category",
    categoryHelp: "Select the type of sound you want to generate",
    public: "Public",
    publicHelp: "Make this sound available to other users in the library",
    tags: "Tags",
    tagsPlaceholder: "Enter tags separated by commas (e.g., lofi, hiphop, chill)",
    tagsHelp: "Add descriptive tags to guide the music generation, separated by commas",
    tagGenres: "Genres",
    tagInstruments: "Instruments",
    tagTempo: "Tempo",
    tagMood: "Mood",
    instrumentalMode: "Instrumental Mode (No Vocals)",
    input: {
      label: "Prompt",
      placeholder: "Enter sound description (English recommended)",
      notRequired: "Prompt input not required",
      warning: "Sounds that violate the policy cannot be generated, and credit is not guaranteed in such cases.",
      error: {
        button: "Having trouble?",
        tooltip: "If errors persist, there may be a problem on the provider side. Please wait and try again later.",
      },
    },
    submit: "Generate Sound",
  },
  mySounds: "My Sounds",
  processing: "Generating sound...\nUsually completes within 1-2 minutes.",
  sampleSounds: "Sample Sounds",
  error: {
    generate: "Failed to generate the sound.\nPlease check for policy violations and try again later.",
    required: {
      prompt: "Please enter a prompt.",
      audio: "Please upload an audio file for this model.",
    },
    max: {
      prompt: "Prompt is too long, please shorten it.",
      audioSize: "Audio file size must be 30MB or less.",
      audioDuration: "Audio duration must be 60 seconds or less.",
    },
    processingLimit:
      "Processing limit exceeded. You have {{current}} requests in progress. Your plan allows up to {{limit}} simultaneous requests.",
    prompt: {
      generate: "Error generating prompt",
      update: "Error enhancing prompt",
    },
  },
  startGenerating: "Your sound generation request has been added to the queue.",
  soundMenu: {
    download: "Download",
    delete: "Delete",
  },
  message: {
    deleted: "Sound has been deleted.",
    error: "Error",
  },
  noImage: "No image available",
  inspire: {
    icon: "Sound Inspiration",
    description: "Click on a category to add it to your prompt",
    genre: {
      rock: "Rock",
      pop: "Pop",
      hiphop: "Hip-Hop",
      jazz: "Jazz",
      classical: "Classical",
      electronic: "Electronic",
      ambient: "Ambient",
      blues: "Blues",
      country: "Country",
      folk: "Folk",
      reggae: "Reggae",
      rnb: "R&B",
      metal: "Metal",
      punk: "Punk",
      indie: "Indie",
      latin: "Latin",
    },
    mood: {
      happy: "Happy",
      sad: "Sad",
      energetic: "Energetic",
      calm: "Calm",
      relaxed: "Relaxed",
      chill: "Chill",
      dreamy: "Dreamy",
      romantic: "Romantic",
      nostalgic: "Nostalgic",
      dramatic: "Dramatic",
      dark: "Dark",
      emotional: "Emotional",
      melancholic: "Melancholic",
      uplifting: "Uplifting",
      epic: "Epic",
      mysterious: "Mysterious",
    },
    sfx: {
      water: "Water sounds",
      wind: "Wind sounds",
      rain: "Rain sounds",
      thunder: "Thunder",
      fire: "Fire crackling",
      forest: "Forest sounds",
      birds: "Bird calls",
      animals: "Animal sounds",
      ocean: "Ocean waves",
      city: "City ambience",
      footsteps: "Footsteps",
      machinery: "Machinery",
      digital: "Digital sounds",
      explosion: "Explosion",
      impact: "Impact sounds",
      whoosh: "Whoosh sounds",
    },
    bpm: {
      slow: "Slow",
      medium: "Medium",
      fast: "Fast",
      apply: "Apply BPM",
    },
    dice: "Generate sample prompt",
    improve: "Enhance prompt",
  },
};
export default junoSound;
